import React from "react";
import styled from "styled-components";
import ShimmerView from "../ShimmerView";

const ShimmerWrapper = styled.div(({ theme }) => ({
    width: "100%",
    height: 200,
    borderRadius: theme.spacing.medium,
    marginTop: theme.spacing.small,
    marginBottom: theme.spacing.small,
    overflow: "hidden",
}));

const ReferralsShimmer = () => {
    return (
        <ShimmerWrapper>
            <ShimmerView />
        </ShimmerWrapper>
    );
};

export default ReferralsShimmer;
